import { render, staticRenderFns } from "./ModalOptionsList.vue?vue&type=template&id=8975f00c&scoped=true"
import script from "./ModalOptionsList.vue?vue&type=script&lang=js"
export * from "./ModalOptionsList.vue?vue&type=script&lang=js"
import style0 from "./ModalOptionsList.vue?vue&type=style&index=0&id=8975f00c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8975f00c",
  null
  
)

export default component.exports